import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import kanbanReducer from './slices/kanban';
import eventModalReducer from './slices/eventModal';
import storeReducer from './slices/store';
import { EventsApi } from './api/events.api';
import { TicketsApi } from './api/tickets.api';
import { UsersApi } from './api/users.api';
import { SurveysApi } from './api/surveys.api';
import { ContactsApi } from './api/contacts.api';
import { AdminApi } from './api/admin.api';
import { EventCategoriesApi } from './api/eventCatygory.api';
import { MenusApi } from './api/menus.api';
import { ReservationsApi } from './api/reservations.api';
import { AccessRequestsApi } from './api/accessRequests.api';
import { emailTemplatesApi } from './api/emailTemplates.api';
import { HiddenLinksApi } from './api/hiddenLinks.api';
import { TicketCategoriesApi } from './api/ticketCategories.api';
import { BusTripsApi } from './api/busTrips.api';
import { MailCampaignApi } from './api/mailcampaigns.api';
import { FaqsApi } from './api/faqs.api';
import EventArtistLineup from 'src/sections/@dashboard/events/artistLineup/EventArtistLineup';
import { ArtistLineupApi } from './api/artistLineup.api';
import { OrganizersApi } from './api/organisers.api';
import { PassCultureApi } from './api/PassCulture.api';
import { G } from '@react-pdf/renderer';
import { GoodiesApi } from './api/goodies.api';
import { AnalyticsApi } from './api/analytics.api';
import { PromocodeAnalyticsApi } from './api/promocodeAnalytics.api';
import { EnhancedOrganizationsApi } from './api/organizations.enhanced.api';
import { shareBoostApi } from './api/shareboost.api';
import { stripeApi } from './api/stripe.api';
import { followersApi } from './api/followers.api';
import { engineersApi } from './api/engineers.api';
import { organizationStripeApi } from './api/organizationStripe.api';
import { financialApi } from './api/financial.api';
import { CampaignApi } from './api/campaign.api';
// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};



const rootReducer = combineReducers({
  [EventsApi.reducerPath]: EventsApi.reducer,
  [UsersApi.reducerPath]: UsersApi.reducer,
  [AdminApi.reducerPath]: AdminApi.reducer,
  [EventCategoriesApi.reducerPath]: EventCategoriesApi.reducer,
  [MenusApi.reducerPath]: MenusApi.reducer,
  [SurveysApi.reducerPath]: SurveysApi.reducer,
  [ContactsApi.reducerPath]: ContactsApi.reducer,
  [ReservationsApi.reducerPath]: ReservationsApi.reducer,
  [TicketsApi.reducerPath]: TicketsApi.reducer,
  [AccessRequestsApi.reducerPath]: AccessRequestsApi.reducer,
  [HiddenLinksApi.reducerPath]: HiddenLinksApi.reducer,
  [emailTemplatesApi.reducerPath]: emailTemplatesApi.reducer,
  [TicketCategoriesApi.reducerPath]: TicketCategoriesApi.reducer,
  [BusTripsApi.reducerPath]: BusTripsApi.reducer,
  [MailCampaignApi.reducerPath]: MailCampaignApi.reducer,
  [FaqsApi.reducerPath]: FaqsApi.reducer,
  [ArtistLineupApi.reducerPath]: ArtistLineupApi.reducer,
  [OrganizersApi.reducerPath]: OrganizersApi.reducer,
  [PassCultureApi.reducerPath]: PassCultureApi.reducer,
  [GoodiesApi.reducerPath]: GoodiesApi.reducer,
  [AnalyticsApi.reducerPath]: AnalyticsApi.reducer,
  [PromocodeAnalyticsApi.reducerPath]: PromocodeAnalyticsApi.reducer,
  [EnhancedOrganizationsApi.reducerPath]: EnhancedOrganizationsApi.reducer,
  [shareBoostApi.reducerPath]: shareBoostApi.reducer,
  [stripeApi.reducerPath]: stripeApi.reducer,
  [followersApi.reducerPath]: followersApi.reducer,
  [engineersApi.reducerPath]: engineersApi.reducer,
  [organizationStripeApi.reducerPath]: organizationStripeApi.reducer,
  [financialApi.reducerPath]: financialApi.reducer,
  [CampaignApi.reducerPath]: CampaignApi.reducer,
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  eventModal: eventModalReducer,
  kanban: kanbanReducer,
  store: storeReducer,
  product: persistReducer(productPersistConfig, productReducer),
});

export { rootPersistConfig, rootReducer };
